import React, { useEffect, useMemo, useState } from "react";
import {
  ImgDiv,
  MainDiv,
  ProductsDiv,
  ProductsImgDiv,
  TitleText
} from "./styled";

import bgc from "../../assets/images/bgc/bgc4.jpg";
import { products } from "./products"; // путь подправь под себя

export const PaintingsPage = () => {
  const [isVisible, setIsVisible] = useState([]);
  const lang = localStorage.getItem("lang") || "en";

  // Только те, что в наличии
  const paintings = useMemo(
    () => products.filter(p => p.instock),
    []
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsVisible(Array(paintings.length).fill(false));
  }, [paintings.length]);

  useEffect(() => {
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const index = Number(entry.target.dataset.index);
        if (entry.isIntersecting) {
          setIsVisible(prev => {
            const updated = [...prev];
            updated[index] = true;
            return updated;
          });
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1
    });

    paintings.forEach((_, index) => {
      const el = document.getElementById(`products-${index}`);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [paintings]);

  const getTitle = (item) => {
    if (lang === "ru") return item.titleRU;
    if (lang === "am") return item.titleAM;
    return item.titleEN;
  };

  return (
    <MainDiv>
      <ImgDiv>
        <img src={bgc} alt="Background" />
      </ImgDiv>

      <TitleText>
        <span>Paintings</span>
      </TitleText>

      <ProductsDiv>
        {paintings.map((item, i) => (
          <ProductsImgDiv
            id={`products-${i}`}
            data-index={i}
            key={item._id}
            to={`/product/id/${item._id}`}
            $text={getTitle(item)}
            style={{
              opacity: isVisible[i] ? 1 : 0,
              transform: isVisible[i]
                ? "translateX(0)"
                : i % 2 === 0
                ? "translateX(-30px)"
                : "translateX(30px)",
              transition: "opacity 1.5s, transform 1.5s"
            }}
          >
            <img
              src={item.imgs[0]}
              alt={item.titleEN}
            />
          </ProductsImgDiv>
        ))}
      </ProductsDiv>
    </MainDiv>
  );
};
